import type { ArchbaseRemoteApiClient } from '@archbase/data'
import { injectable, inject } from 'inversify'
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core'
import type { JobListResponse } from '@domain/job/JobDto'

@injectable()
export class DoclenzJobService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  /**
   * Jobs recentes, do mais novo para o mais antigo.
   *
   * Cobre só a janela de retenção — 1 h enquanto processa, 24 h depois de completo. É visão
   * operacional, não histórico: um job de ontem à noite já não está aqui.
   */
  async findAll(params: { tenantId?: string; status?: string; limit?: number } = {}): Promise<JobListResponse> {
    const query = new URLSearchParams()
    if (params.tenantId) query.set('tenantId', params.tenantId)
    if (params.status) query.set('status', params.status)
    query.set('limit', String(params.limit ?? 50))
    return this.client.get(`/v1/admin/jobs?${query.toString()}`)
  }
}
